import useTourManager from '../../hooks/useTourManager';
import { tourSteps } from '../../config/trendsConfig';

const useTrendsTour = ({ isAuthenticated, processedTrendData, countries = [], hasSeenNavbarTour }) => {
  // Filter out the filter step if countries <= 1
  const filteredSteps = tourSteps.filter(step => {
    if (step.element === '[data-intro="filter-options"]') {
      return countries.length > 1;
    }
    return true;
  });

  // Use shared tour manager
  const { startTour } = useTourManager({
    tourName: 'trendsTour',
    cookieName: 'trendsTourSeen',
    isAuthenticated,
    dataReady: processedTrendData.length > 0,
    hasSeenNavbarTour,
    pageSteps: filteredSteps
  });

  return { startTour };
};

export default useTrendsTour;
